<template>
  <div class="app-steps">
    <app-step-one v-if="true"></app-step-one>
    <app-step-two v-if="false"></app-step-two>
  </div>
</template>

<script setup>
import AppStepOne from './step-one/index.vue'
import AppStepTwo from './step-two/index.vue'
</script>
